
<template>
    <div>
        <!-- Create Modal -->
        <div class="modal fade" id="product-create-modal-product" tabindex="-1" aria-labelledby="product-create-modal-product" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header py-2">
                    <h5 class="modal-title mb-0">
                        {{$t('create_product')}}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body product-create-body">
                    
                    <div v-if="false" class="row">
                        <!-- Left Column: Form Fields -->
                        <div class="col-lg-8">
                            <!-- Basic Information -->
                            <div class="section-header-compact mb-2">
                                <h6 class="text-muted mb-0 d-flex align-items-center">
                                    <AppIcon name="bi-info-circle" class="bi bi-info-circle me-2" />
                                    {{$t('basic_information')}}
                                </h6>
                            </div>

                            <div class="row">
                                <div v-if="visibleColumns.label" class="col-sm-12 mb-2">
                                    <label class="form-label-compact">
                                        {{$t('label')}} <span class="text-danger">*</span>
                                    </label>
                                    <input 
                                        v-model="product.label" 
                                        type="text" 
                                        class="form-control form-control-sm"
                                    >
                                </div>
                                <div v-if="visibleColumns.sku" class="col-sm-5 mb-2">
                                    <label class="form-label-compact">{{$t('sku')}}</label>
                                    <input 
                                        v-model="product.sku" 
                                        type="text" 
                                        class="form-control form-control-sm" 
                                        :placeholder="$t('sku')"
                                    >
                                </div>
                                <div v-if="visibleColumns.supplier && helper.checkModuleIsEnabled('suppliers')" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('supplier')}}</label>
                                    <auto-complete  
                                        v-if="createSuplierState === false" 
                                        @emitAutoCompleteSupplier="emitAutoCompleteSupplier" 
                                        :defaultValue="product?.supplier?.name"
                                        entity="suppliers"
                                        emitEvent="emitAutoCompleteSupplier"
                                    ></auto-complete>
                                    <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateSupplierModal">
                                        <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_supplier')}}
                                    </a>
                                </div>
                                <div v-if="visibleColumns.category && helper.checkModuleIsEnabled('categories')" class="col-sm-4 mb-2"> 
                                    <label class="form-label-compact">{{$t('category')}}</label>
                                    <auto-complete  
                                        v-if="createCategoryState === false" 
                                        @emitAutoCompleteCategory="emitAutoCompleteCategory" 
                                        :defaultValue="product?.category?.name"
                                        entity="categories"
                                        emitEvent="emitAutoCompleteCategory"
                                    ></auto-complete>
                                    <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateCategoryModal">
                                        <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_category')}}
                                    </a>
                                </div>
                                <div v-if="visibleColumns.barcode" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('barcode')}}</label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            v-model="product.barcode" 
                                            type="text" 
                                            class="form-control" 
                                            :placeholder="$t('barcode')"
                                        >
                                        <button 
                                            class="btn btn-outline-secondary dropdown-toggle" 
                                            type="button" 
                                            data-bs-toggle="dropdown" 
                                            aria-expanded="false"
                                            :title="$t('barcode_options')"
                                        >
                                            <AppIcon name="bi-upc-scan" class="bi bi-upc-scan" />
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end">
                                            <li>
                                                <a class="dropdown-item" href="#" @click.prevent="openBarcodeModalForScan">
                                                    <AppIcon name="bi-camera" class="bi bi-camera me-2" />{{$t('scan_barcode')}}
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="#" @click.prevent="generateAndSetBarcode">
                                                    <AppIcon name="bi-upc" class="bi bi-upc me-2" />{{$t('generate_barcode')}}
                                                </a>
                                            </li>
                                            <li v-if="product.barcode">
                                                <hr class="dropdown-divider">
                                            </li>
                                            <li v-if="product.barcode">
                                                <a class="dropdown-item" href="#" @click.prevent="downloadBarcode">
                                                    <AppIcon name="bi-download" class="bi bi-download me-2" />{{$t('download_barcode')}}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <!-- Pricing -->
                            <div v-if="!product.has_variants && visibleColumns.price" class="section-header-compact mb-2 mt-3">
                                <h6 class="text-muted mb-0 d-flex align-items-center">
                                    <AppIcon name="bi-cash-coin" class="bi bi-cash-coin me-2" />
                                    {{$t('pricing')}}
                                </h6>
                            </div>

                            <div v-if="!product.has_variants && visibleColumns.price" class="border-0 shadow-none mb-2">
                                <div class="form-check form-switch mb-0">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        id="toggleTTCAdd" 
                                        v-model="product.price_includes_tax"
                                    >
                                    <label class="form-check-label small" for="toggleTTCAdd">
                                        {{ product.price_includes_tax ? $t('price_with_tax') : $t('price_without_tax') }}
                                    </label>
                                </div>
                            </div>

                            <div class="row" v-if="!product.has_variants && product.price_includes_tax">
                                <div class="col-sm-6 mb-2">
                                    <label class="form-label-compact">{{$t('price_with_tax')}} <span class="text-danger">*</span></label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            v-model.number="product.price_with_tax" 
                                            type="number" 
                                            class="form-control" 
                                            min="0" 
                                            step="0.01" 
                                            inputmode="decimal"
                                            @input="calculatePriceFromTTC"
                                            @focus="handleInputFocus(product, 'price_with_tax')"
                                            @blur="handleInputBlur(product, 'price_with_tax')"
                                        >
                                        <span class="input-group-text">{{business.currency}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-2">
                                    <label class="form-label-compact">{{$t('vat')}} %</label>
                                    <input 
                                        v-model.number="product.vat" 
                                        type="number" 
                                        class="form-control form-control-sm" 
                                        min="0" 
                                        max="100" 
                                        step="0.01" 
                                        inputmode="decimal"
                                        @input="calculatePriceFromTTC"
                                        @focus="handleInputFocus(product, 'vat')"
                                        @blur="handleInputBlur(product, 'vat')"
                                    >
                                </div>
                            </div>

                            <div class="row" v-if="!product.has_variants && visibleColumns.price">
                                <div v-if="visibleColumns.purchase_price" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('purchase_price')}} <span class="text-danger">*</span></label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            v-model.number="product.purchase_price" 
                                            type="number" 
                                            class="form-control" 
                                            min="0" 
                                            step="0.01" 
                                            inputmode="decimal"
                                            @focus="handleInputFocus(product, 'purchase_price')"
                                            @blur="handleInputBlur(product, 'purchase_price')"
                                        >
                                        <span class="input-group-text">{{business.currency}}</span>
                                    </div>
                                </div>
                                <div v-if="visibleColumns.price" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('price')}} (HT) <span class="text-danger">*</span></label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            v-model.number="product.price" 
                                            type="number" 
                                            class="form-control" 
                                            min="0" 
                                            step="0.01" 
                                            inputmode="decimal"
                                            :readonly="product.price_includes_tax"
                                            :class="{'bg-light': product.price_includes_tax}"
                                            @input="!product.price_includes_tax && calculateTTCFromPrice()"
                                            @focus="handleInputFocus(product, 'price')"
                                            @blur="handleInputBlur(product, 'price')"
                                        >
                                        <span class="input-group-text">{{business.currency}}</span>
                                    </div>
                                    <small v-if="product.price_includes_tax" class="text-muted" style="font-size: 0.7rem;">
                                        <AppIcon name="bi-info-circle" class="bi bi-info-circle me-1" />{{$t('calculated_automatically')}}
                                    </small>
                                </div>
                                <div v-if="visibleColumns.profit_margin" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('profit_margin')}}</label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            type="text" 
                                            class="form-control bg-light" 
                                            :value="calculateMargin()" 
                                            readonly
                                        >
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Inventory -->
                            <div class="section-header-compact mb-2 mt-3">
                                <h6 class="text-muted mb-0 d-flex align-items-center">
                                    <AppIcon name="bi-box-seam" class="bi bi-box-seam me-2" />
                                    {{$t('inventory')}}
                                </h6>
                            </div>

                            <!-- Product Type Toggle -->
                            <div v-if="visibleColumns.has_variants" class="card bg-light border-0 mb-2 p-2">
                                <div class="form-check form-switch mb-0">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        id="hasVariantsSwitch" 
                                        v-model="product.has_variants"
                                        @change="onHasVariantsToggle"
                                        style="cursor: pointer;"
                                    >
                                    <label class="form-check-label" for="hasVariantsSwitch" style="cursor: pointer; font-size: 0.85rem;">
                                        <AppIcon name="bi-collection" class="bi bi-collection me-1" />
                                        <strong>{{$t('product_has_variants')}}</strong>
                                        <small class="text-muted d-block" style="font-size: 0.75rem;">
                                            {{$t('enable_for_products_with_different_sizes_colors_etc')}}
                                        </small>
                                    </label>
                                </div>
                            </div>

                            <!-- Single Product Inventory (shown when has_variants is false) -->
                            <div v-if="!product.has_variants && (visibleColumns.quantity || visibleColumns.warehouse)" class="row">
                                <div v-if="visibleColumns.unity" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('unity')}}</label>
                                    <select v-model="product.unity" class="form-select form-select-sm">
                                        <option value="unit">{{$t('unit')}}</option>
                                        <option value="kg">kg</option>
                                        <option value="g">g</option>
                                        <option value="L">L</option>
                                        <option value="ml">ml</option>
                                        <option value="m">m</option>
                                        <option value="m²">m²</option>
                                    </select>
                                </div>
                                <div v-if="visibleColumns.unity && product.unity === 'm²'" class="col-sm-8 mb-2">
                                    <div class="card bg-light border-0 p-2">
                                        <label class="form-label-compact small text-primary mb-1">
                                            <AppIcon name="bi-calculator" class="bi bi-calculator me-1" />{{$t('carpet_area_helper')}}
                                        </label>
                                        <div class="row g-2">
                                            <div class="col-6">
                                                <div class="input-group input-group-sm">
                                                    <span class="input-group-text bg-white" style="font-size: 0.7rem;">W</span>
                                                    <input 
                                                        v-model.number="product.unity_width" 
                                                        type="number" 
                                                        class="form-control" 
                                                        placeholder="Width"
                                                        @input="calculateCarpetArea"
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="input-group input-group-sm">
                                                    <span class="input-group-text bg-white" style="font-size: 0.7rem;">L</span>
                                                    <input 
                                                        v-model.number="product.unity_length" 
                                                        type="number" 
                                                        class="form-control" 
                                                        placeholder="Length"
                                                        @input="calculateCarpetArea"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="visibleColumns.quantity" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('quantity')}} <span class="text-danger">*</span></label>
                                    <input 
                                        v-model.number="product.quantity" 
                                        type="number" 
                                        class="form-control form-control-sm" 
                                        step="0.001"
                                        min="0" 
                                        inputmode="decimal"
                                        @focus="handleInputFocus(product, 'quantity')"
                                        @blur="handleInputBlur(product, 'quantity')"
                                    >
                                </div>
                                <div v-if="visibleColumns.min_quantity" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('min_quantity')}}</label>
                                    <input 
                                        v-model.number="product.min_quantity" 
                                        type="number" 
                                        class="form-control form-control-sm" 
                                        step="0.001"
                                        min="0" 
                                        inputmode="decimal"
                                        @focus="handleInputFocus(product, 'min_quantity')"
                                        @blur="handleInputBlur(product, 'min_quantity')"
                                    >
                                    <small class="text-muted" style="font-size: 0.65rem; white-space: nowrap; display: block; overflow: hidden; text-overflow: ellipsis;" :title="$t('alert_when_stock_below')">
                                        <AppIcon name="bi-exclamation-triangle" class="bi bi-exclamation-triangle me-1" />{{$t('alert_when_stock_below')}}
                                    </small>
                                </div>
                                <div v-if="visibleColumns.warehouse && helper.checkModuleIsEnabled('warehouses')" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('warehouse')}}</label>
                                    <auto-complete  
                                        v-if="createWarehouseState === false" 
                                        @emitAutoCompleteWarehouse="emitAutoCompleteWarehouse" 
                                        :defaultValue="product?.warehouse?.name"
                                        entity="warehouses"
                                        emitEvent="emitAutoCompleteWarehouse"
                                    ></auto-complete>
                                    <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateWarehouseModal">
                                        <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_warehouse')}}
                                    </a>
                                </div>
                            </div>

                            <!-- Product Variants Section (shown when has_variants is true) -->
                            <div v-else class="variants-section">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="form-label-compact mb-0">
                                        <AppIcon name="bi-collection" class="bi bi-collection me-1" />
                                        {{$t('product_variants')}}
                                    </label>
                                    <button 
                                        type="button" 
                                        @click="addVariant" 
                                        class="btn btn-sm btn-outline-primary"
                                    >
                                        <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />
                                        {{$t('add_variant')}}
                                    </button>
                                </div>

                                <!-- Variants List -->
                                <div v-if="product.variants.length === 0" class="alert alert-info mb-2 py-2 px-2">
                                    <small>
                                        <AppIcon name="bi-info-circle" class="bi bi-info-circle me-1" />
                                        {{$t('no_variants_added_click_add_variant')}}
                                    </small>
                                </div>

                                <div v-for="(variant, index) in product.variants" :key="index" class="variant-card mb-2">
                                    <div class="card border">
                                        <div class="card-header bg-light py-2 px-2 d-flex justify-content-between align-items-center">
                                            <small class="fw-bold text-muted">
                                                <AppIcon name="bi-tag" class="bi bi-tag me-1" />
                                                {{$t('variant')}} #{{index + 1}}
                                            </small>
                                            <button 
                                                type="button" 
                                                @click="removeVariant(index)" 
                                                class="btn btn-sm btn-outline-danger"
                                                style="padding: 2px 8px; font-size: 0.75rem;"
                                            >
                                                <AppIcon name="bi-trash" class="bi bi-trash" />
                                            </button>
                                        </div>
                                        <div class="card-body p-2">
                                            <div class="row">
                                                <div class="col-md-6 mb-2">
                                                    <label class="form-label-compact">{{$t('variant_name')}} <span class="text-danger">*</span></label>
                                                    <input 
                                                        v-model="variant.name" 
                                                        type="text" 
                                                        class="form-control form-control-sm" 
                                                        :placeholder="$t('e_g_red_large_cotton')"
                                                    >
                                                    <small class="text-muted" style="font-size: 0.7rem;">{{$t('e_g_size_color_material')}}</small>
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('sku')}}</label>
                                                    <input 
                                                        v-model="variant.sku" 
                                                        type="text" 
                                                        class="form-control form-control-sm" 
                                                        :placeholder="$t('sku')"
                                                    >
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('barcode')}}</label>
                                                    <div class="input-group input-group-sm">
                                                        <input 
                                                            v-model="variant.barcode" 
                                                            type="text" 
                                                            class="form-control form-control-sm" 
                                                            :placeholder="$t('barcode')"
                                                        >
                                                        <button 
                                                            class="btn btn-outline-secondary dropdown-toggle" 
                                                            type="button" 
                                                            data-bs-toggle="dropdown" 
                                                            aria-expanded="false"
                                                            style="padding: 0.375rem 0.5rem; font-size: 0.75rem;"
                                                        >
                                                            <AppIcon name="bi-upc-scan" class="bi bi-upc-scan" />
                                                        </button>
                                                        <ul class="dropdown-menu dropdown-menu-end">
                                                            <li>
                                                                <a class="dropdown-item" href="#" @click.prevent="openVariantBarcodeModal(index, 'scan')">
                                                                    <AppIcon name="bi-camera" class="bi bi-camera me-2" />{{$t('scan_barcode')}}
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#" @click.prevent="generateVariantBarcode(index)">
                                                                    <AppIcon name="bi-upc" class="bi bi-upc me-2" />{{$t('generate_barcode')}}
                                                                </a>
                                                            </li>
                                                            <li v-if="variant.barcode">
                                                                <hr class="dropdown-divider">
                                                            </li>
                                                            <li v-if="variant.barcode">
                                                                <a class="dropdown-item" href="#" @click.prevent="downloadVariantBarcode(variant.barcode)">
                                                                    <AppIcon name="bi-download" class="bi bi-download me-2" />{{$t('download_barcode')}}
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('purchase_price')}} <span class="text-danger">*</span></label>
                                                    <input 
                                                        v-model.number="variant.purchase_price" 
                                                        type="number" 
                                                        class="form-control form-control-sm" 
                                                        min="0" 
                                                        step="0.01"
                                                        inputmode="decimal"
                                                        @focus="handleInputFocus(variant, 'purchase_price')"
                                                        @blur="handleInputBlur(variant, 'purchase_price')"
                                                    >
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('price')}} <span class="text-danger">*</span></label>
                                                    <input 
                                                        v-model.number="variant.price" 
                                                        type="number" 
                                                        class="form-control form-control-sm" 
                                                        min="0" 
                                                        step="0.01"
                                                        inputmode="decimal"
                                                        @focus="handleInputFocus(variant, 'price')"
                                                        @blur="handleInputBlur(variant, 'price')"
                                                    >
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('quantity')}} <span class="text-danger">*</span></label>
                                                    <input 
                                                        v-model.number="variant.quantity" 
                                                        type="number" 
                                                        class="form-control form-control-sm" 
                                                        step="0.001"
                                                        min="0"
                                                        inputmode="decimal"
                                                        @focus="handleInputFocus(variant, 'quantity')"
                                                        @blur="handleInputBlur(variant, 'quantity')"
                                                    >
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('min_quantity')}}</label>
                                                    <input 
                                                        v-model.number="variant.min_quantity" 
                                                        type="number" 
                                                        class="form-control form-control-sm" 
                                                        step="0.001"
                                                        min="0"
                                                        inputmode="decimal"
                                                        @focus="handleInputFocus(variant, 'min_quantity')"
                                                        @blur="handleInputBlur(variant, 'min_quantity')"
                                                    >
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <label class="form-label-compact">{{$t('variant_image')}}</label>
                                                    <div class="variant-image-upload">
                                                        <div v-if="variant.image" class="position-relative d-inline-block">
                                                            <img :src="variant.image" class="variant-preview-image" style="width: 100px;height:100px" alt="Variant">
                                                            <button 
                                                                type="button" 
                                                                @click="variant.image = null" 
                                                                class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                                                style="padding: 2px 6px; font-size: 0.7rem;"
                                                            >
                                                                <AppIcon name="bi-x" class="bi bi-x" />
                                                            </button>
                                                        </div>
                                                        <div v-else>
                                                            <input 
                                                                type="file" 
                                                                :id="`variantFileInput${index}`"
                                                                @change="handleVariantFileUpload($event, index)" 
                                                                accept="image/*" 
                                                                class="d-none"
                                                            >
                                                            <label 
                                                                :for="`variantFileInput${index}`"
                                                                class="btn btn-sm btn-outline-secondary mb-0"
                                                                style="cursor: pointer;"
                                                            >
                                                                <AppIcon name="bi-image" class="bi bi-image me-1" />
                                                                {{$t('upload_image')}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Notes -->
                            <div v-if="visibleColumns.notes" class="product-notes-collapse mt-3">
                                <button
                                    type="button"
                                    class="product-notes-toggle"
                                    :aria-expanded="notesExpanded ? 'true' : 'false'"
                                    @click="notesExpanded = !notesExpanded"
                                >
                                    <AppIcon :name="notesExpanded ? 'bi-chevron-down' : 'bi-chevron-right'" class="product-notes-chevron" />
                                    <span>{{$t('add_note')}}</span>
                                    <span class="product-notes-optional">({{$t('optional')}})</span>
                                </button>
                                <div v-if="notesExpanded" class="pt-2">
                                    <textarea
                                        v-model="product.notes"
                                        class="form-control form-control-sm"
                                        :placeholder="$t('add_notes')"
                                        rows="2"
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Right Column: Image Upload -->
                        <div v-if="visibleColumns.image" class="col-lg-4 mb-2">
                            <label class="form-label-compact">{{$t('image')}}</label>
                            <div class="image-preview">
                                <div 
                                    class="drop-zone-compact" 
                                    @dragover.prevent
                                    @drop.prevent="handleFileDrop"
                                    @click="$refs.fileInput.click()"
                                    :class="{'has-image': product.image }"
                                >
                                    <img v-if="product.image" :src="product.image" class="preview-image-compact" />
                                    <div v-else class="drop-zone-content">
                                        <AppIcon name="bi-cloud-upload" class="bi bi-cloud-upload mb-2" style="font-size: 28px; color: #6c757d;" />
                                        <p class="mb-1 small fw-semibold">{{$t('drag_drop_or_click')}}</p>
                                        <small class="text-muted" style="font-size: 0.75rem;">{{$t('max_size_5mb')}}</small>
                                    </div>
                                </div>
                                <input 
                                    type="file" 
                                    ref="fileInput" 
                                    @change="handleFileUpload" 
                                    accept="image/*" 
                                    class="d-none"
                                >
                            </div>

                            <!-- Calculation info -->
                            <div v-if="product.price_includes_tax && product.price_with_tax && product.vat" class="mt-2">
                                <div class="alert alert-info mb-0 py-2 px-2">
                                    <small style="font-size: 0.75rem;">
                                        <AppIcon name="bi-calculator" class="bi bi-calculator me-1" />
                                        <strong>{{$t('calculation')}}:</strong><br>
                                        TTC: {{ product.price_with_tax }} {{business.currency}} | 
                                        {{$t('vat')}}: {{ product.vat }}% | 
                                        HT: {{ product.price }} {{business.currency}}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row g-4 align-items-start">
                        <div
                            v-if="hasPrimaryProductFields"
                            :class="visibleColumns.image ? 'col-lg-8' : 'col-12'"
                        >
                            <div v-if="visibleColumns.label" class="product-field">
                                <label for="new-product-name" class="product-field-label">
                                    {{$t('product_name')}} <span class="text-danger">*</span>
                                </label>
                                <input
                                    id="new-product-name"
                                    v-model="product.label"
                                    type="text"
                                    class="form-control product-control"
                                    :placeholder="$t('product_name_placeholder')"
                                >
                            </div>

                            <div v-if="visibleColumns.barcode" class="product-field">
                                <label for="new-product-barcode" class="product-field-label">{{$t('barcode')}}</label>
                                <div class="input-group product-input-group">
                                    <input
                                        id="new-product-barcode"
                                        v-model="product.barcode"
                                        type="text"
                                        class="form-control product-control"
                                        :placeholder="$t('barcode_placeholder')"
                                    >
                                    <button
                                        class="btn product-barcode-button dropdown-toggle"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        :title="$t('barcode_options')"
                                    >
                                        <AppIcon name="bi-upc-scan" />
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end">
                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="openBarcodeModalForScan">
                                                <AppIcon name="bi-camera" class="me-2" />{{$t('scan_barcode')}}
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="generateAndSetBarcode">
                                                <AppIcon name="bi-upc" class="me-2" />{{$t('generate_barcode')}}
                                            </a>
                                        </li>
                                        <li v-if="product.barcode"><hr class="dropdown-divider"></li>
                                        <li v-if="product.barcode">
                                            <a class="dropdown-item" href="#" @click.prevent="downloadBarcode">
                                                <AppIcon name="bi-download" class="me-2" />{{$t('download_barcode')}}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div v-if="!product.has_variants && (visibleColumns.price || visibleColumns.quantity)" class="product-flex-fields">
                                <div
                                    v-if="visibleColumns.price"
                                    class="product-flex-field"
                                >
                                    <div class="product-price-heading">
                                        <label for="new-product-price" class="product-field-label mb-0">
                                            {{$t('sale_price')}} ({{product.price_includes_tax ? 'TTC' : 'HT'}}) <span class="text-danger">*</span>
                                        </label>
                                        <div class="price-mode-toggle" role="group" :aria-label="$t('price_mode')">
                                            <button
                                                type="button"
                                                :class="['price-mode-option', { active: !product.price_includes_tax }]"
                                                :aria-pressed="!product.price_includes_tax ? 'true' : 'false'"
                                                @click="setPriceMode(false)"
                                            >HT</button>
                                            <button
                                                type="button"
                                                :class="['price-mode-option', { active: product.price_includes_tax }]"
                                                :aria-pressed="product.price_includes_tax ? 'true' : 'false'"
                                                @click="setPriceMode(true)"
                                            >TTC</button>
                                        </div>
                                    </div>
                                    <div class="input-group product-input-group">
                                        <input
                                            v-if="!product.price_includes_tax"
                                            id="new-product-price"
                                            v-model.number="product.price"
                                            type="number"
                                            class="form-control product-control"
                                            min="0"
                                            step="0.01"
                                            inputmode="decimal"
                                            placeholder="0,00"
                                            @input="calculateTTCFromPrice"
                                            @focus="handleInputFocus(product, 'price')"
                                            @blur="handleInputBlur(product, 'price')"
                                        >
                                        <input
                                            v-else
                                            id="new-product-price"
                                            v-model.number="product.price_with_tax"
                                            type="number"
                                            class="form-control product-control"
                                            min="0"
                                            step="0.01"
                                            inputmode="decimal"
                                            placeholder="0,00"
                                            @input="calculatePriceFromTTC"
                                            @focus="handleInputFocus(product, 'price_with_tax')"
                                            @blur="handleInputBlur(product, 'price_with_tax')"
                                        >
                                        <span class="input-group-text product-currency">{{business.currency}}</span>
                                    </div>
                                </div>

                                <div
                                    v-if="visibleColumns.quantity"
                                    class="product-flex-field"
                                >
                                    <label for="new-product-quantity" class="product-field-label product-field-label-aligned">
                                        {{$t('initial_quantity')}} <span class="text-danger">*</span>
                                    </label>
                                    <input
                                        id="new-product-quantity"
                                        v-model.number="product.quantity"
                                        type="number"
                                        class="form-control product-control"
                                        min="0"
                                        step="0.001"
                                        inputmode="decimal"
                                        @focus="handleInputFocus(product, 'quantity')"
                                        @blur="handleInputBlur(product, 'quantity')"
                                    >
                                </div>
                            </div>

                            <div v-if="hasAdditionalProductFields" class="product-additional-heading">
                                {{$t('more_details')}}
                            </div>
                            <div v-if="hasAdditionalProductFields" class="product-flex-fields product-additional-fields">
                                <div v-if="visibleColumns.sku" class="product-flex-field">
                                    <label for="new-product-sku" class="product-field-label">{{$t('sku')}}</label>
                                    <input
                                        id="new-product-sku"
                                        v-model="product.sku"
                                        type="text"
                                        class="form-control product-control"
                                        :placeholder="$t('sku')"
                                    >
                                </div>

                                <div v-if="visibleColumns.supplier && helper.checkModuleIsEnabled('suppliers')" class="product-flex-field">
                                    <label class="product-field-label">{{$t('supplier')}}</label>
                                    <auto-complete
                                        v-if="createSuplierState === false"
                                        @emitAutoCompleteSupplier="emitAutoCompleteSupplier"
                                        :defaultValue="product?.supplier?.name"
                                        entity="suppliers"
                                        emitEvent="emitAutoCompleteSupplier"
                                    ></auto-complete>
                                    <a href="#" class="product-create-related" @click.prevent="openCreateSupplierModal">
                                        <AppIcon name="bi-plus-circle" class="me-1" />{{$t('create_new_supplier')}}
                                    </a>
                                </div>

                                <div v-if="visibleColumns.category" class="product-flex-field">
                                    <label class="product-field-label">{{$t('category')}}</label>
                                    <auto-complete
                                        v-if="createCategoryState === false"
                                        @emitAutoCompleteCategory="emitAutoCompleteCategory"
                                        :defaultValue="product?.category?.name"
                                        entity="categories"
                                        emitEvent="emitAutoCompleteCategory"
                                    ></auto-complete>
                                    <a href="#" class="product-create-related" @click.prevent="openCreateCategoryModal">
                                        <AppIcon name="bi-plus-circle" class="me-1" />{{$t('create_new_category')}}
                                    </a>
                                </div>

                                <div v-if="!product.has_variants && visibleColumns.purchase_price" class="product-flex-field">
                                    <label for="new-product-purchase-price" class="product-field-label">
                                        {{$t('purchase_price')}} <span class="text-danger">*</span>
                                    </label>
                                    <div class="input-group product-input-group">
                                        <input
                                            id="new-product-purchase-price"
                                            v-model.number="product.purchase_price"
                                            type="number"
                                            class="form-control product-control"
                                            min="0"
                                            step="0.01"
                                            inputmode="decimal"
                                            placeholder="0,00"
                                            @focus="handleInputFocus(product, 'purchase_price')"
                                            @blur="handleInputBlur(product, 'purchase_price')"
                                        >
                                        <span class="input-group-text product-currency">{{business.currency}}</span>
                                    </div>
                                </div>

                                <div v-if="!product.has_variants && visibleColumns.min_quantity" class="product-flex-field">
                                    <label for="new-product-min-quantity" class="product-field-label">
                                        {{$t('min_quantity')}}
                                    </label>
                                    <input
                                        id="new-product-min-quantity"
                                        v-model.number="product.min_quantity"
                                        type="number"
                                        class="form-control product-control"
                                        min="0"
                                        step="0.001"
                                        inputmode="decimal"
                                        @focus="handleInputFocus(product, 'min_quantity')"
                                        @blur="handleInputBlur(product, 'min_quantity')"
                                    >
                                </div>

                                <div v-if="!product.has_variants && visibleColumns.warehouse && helper.checkModuleIsEnabled('warehouses')" class="product-flex-field">
                                    <label class="product-field-label">{{$t('warehouse')}}</label>
                                    <auto-complete
                                        v-if="createWarehouseState === false"
                                        @emitAutoCompleteWarehouse="emitAutoCompleteWarehouse"
                                        :defaultValue="product?.warehouse?.name"
                                        entity="warehouses"
                                        emitEvent="emitAutoCompleteWarehouse"
                                    ></auto-complete>
                                    <a href="#" class="product-create-related" @click.prevent="openCreateWarehouseModal">
                                        <AppIcon name="bi-plus-circle" class="me-1" />{{$t('create_new_warehouse')}}
                                    </a>
                                </div>

                                <div v-if="!product.has_variants && visibleColumns.unity" class="product-flex-field">
                                    <label for="new-product-unit" class="product-field-label">{{$t('unity')}}</label>
                                    <select id="new-product-unit" v-model="product.unity" class="form-select product-control">
                                        <option value="unit">{{$t('unit')}}</option>
                                        <option value="kg">kg</option>
                                        <option value="g">g</option>
                                        <option value="L">L</option>
                                        <option value="ml">ml</option>
                                        <option value="m">m</option>
                                        <option value="m²">m²</option>
                                    </select>
                                </div>

                                <div v-if="!product.has_variants && visibleColumns.profit_margin" class="product-flex-field">
                                    <label for="new-product-margin" class="product-field-label">{{$t('profit_margin')}}</label>
                                    <div class="input-group product-input-group">
                                        <input
                                            id="new-product-margin"
                                            type="text"
                                            class="form-control product-control bg-light"
                                            :value="calculateMargin()"
                                            readonly
                                        >
                                        <span class="input-group-text product-currency">%</span>
                                    </div>
                                </div>

                                <div v-if="visibleColumns.has_variants" class="product-flex-field product-flex-field--full">
                                    <div class="product-variants-toggle">
                                        <div>
                                            <strong>{{$t('product_has_variants')}}</strong>
                                            <small>{{$t('enable_for_products_with_different_sizes_colors_etc')}}</small>
                                        </div>
                                        <div class="form-check form-switch mb-0">
                                            <input
                                                id="new-product-has-variants"
                                                v-model="product.has_variants"
                                                class="form-check-input"
                                                type="checkbox"
                                                @change="onHasVariantsToggle"
                                            >
                                        </div>
                                    </div>
                                </div>

                                <div v-if="product.has_variants" class="product-flex-field product-flex-field--full">
                                    <div class="product-variants-header">
                                        <strong>{{$t('product_variants')}}</strong>
                                        <button type="button" class="btn btn-sm btn-outline-primary" @click="addVariant">
                                            <AppIcon name="bi-plus" class="me-1" />{{$t('add_variant')}}
                                        </button>
                                    </div>

                                    <div v-for="(variant, index) in product.variants" :key="index" class="product-variant-card">
                                        <div class="product-variant-card-header">
                                            <strong>{{$t('variant')}} #{{index + 1}}</strong>
                                            <button type="button" class="btn btn-sm btn-outline-danger" @click="removeVariant(index)">
                                                <AppIcon name="bi-trash" />
                                            </button>
                                        </div>
                                        <div class="product-flex-fields product-variant-fields">
                                            <div class="product-flex-field">
                                                <label class="product-field-label">{{$t('variant_name')}} <span class="text-danger">*</span></label>
                                                <input v-model="variant.name" type="text" class="form-control product-control" :placeholder="$t('e_g_red_large_cotton')">
                                            </div>
                                            <div v-if="visibleColumns.sku" class="product-flex-field">
                                                <label class="product-field-label">{{$t('sku')}}</label>
                                                <input v-model="variant.sku" type="text" class="form-control product-control" :placeholder="$t('sku')">
                                            </div>
                                            <div v-if="visibleColumns.barcode" class="product-flex-field">
                                                <label class="product-field-label">{{$t('barcode')}}</label>
                                                <div class="input-group product-input-group">
                                                    <input v-model="variant.barcode" type="text" class="form-control product-control" :placeholder="$t('barcode_placeholder')">
                                                    <button type="button" class="btn product-barcode-button dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <AppIcon name="bi-upc-scan" />
                                                    </button>
                                                    <ul class="dropdown-menu dropdown-menu-end">
                                                        <li>
                                                            <a class="dropdown-item" href="#" @click.prevent="openVariantBarcodeModal(index, 'scan')">
                                                                <AppIcon name="bi-camera" class="me-2" />{{$t('scan_barcode')}}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a class="dropdown-item" href="#" @click.prevent="generateVariantBarcode(index)">
                                                                <AppIcon name="bi-upc" class="me-2" />{{$t('generate_barcode')}}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div v-if="visibleColumns.purchase_price" class="product-flex-field">
                                                <label class="product-field-label">{{$t('purchase_price')}} <span class="text-danger">*</span></label>
                                                <input v-model.number="variant.purchase_price" type="number" class="form-control product-control" min="0" step="0.01">
                                            </div>
                                            <div v-if="visibleColumns.price" class="product-flex-field">
                                                <label class="product-field-label">{{$t('sale_price')}} <span class="text-danger">*</span></label>
                                                <input v-model.number="variant.price" type="number" class="form-control product-control" min="0" step="0.01">
                                            </div>
                                            <div v-if="visibleColumns.quantity" class="product-flex-field">
                                                <label class="product-field-label">{{$t('initial_quantity')}} <span class="text-danger">*</span></label>
                                                <input v-model.number="variant.quantity" type="number" class="form-control product-control" min="0" step="0.001">
                                            </div>
                                            <div v-if="visibleColumns.min_quantity" class="product-flex-field">
                                                <label class="product-field-label">{{$t('min_quantity')}}</label>
                                                <input v-model.number="variant.min_quantity" type="number" class="form-control product-control" min="0" step="0.001">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="visibleColumns.image"
                            :class="hasPrimaryProductFields ? 'col-lg-4' : 'col-12'"
                        >
                            <div
                                class="product-image-dropzone"
                                :class="{'has-image': product.image}"
                                role="button"
                                tabindex="0"
                                @dragover.prevent
                                @drop.prevent="handleFileDrop"
                                @click="$refs.fileInput.click()"
                                @keydown.enter.prevent="$refs.fileInput.click()"
                                @keydown.space.prevent="$refs.fileInput.click()"
                            >
                                <img v-if="product.image" :src="product.image" class="product-image-preview" :alt="product.label || $t('product_name')">
                                <div v-else class="product-image-placeholder">
                                    <AppIcon name="bi-cloud-arrow-up" class="product-upload-icon" />
                                    <strong>{{$t('add_image')}}</strong>
                                    <span>{{$t('supported_product_images')}}</span>
                                </div>
                            </div>
                            <input
                                ref="fileInput"
                                type="file"
                                class="d-none"
                                accept="image/png,image/jpeg"
                                @change="handleFileUpload"
                            >
                        </div>
                    </div>

                    <collapsible-notes-field
                        v-if="visibleColumns.notes"
                        v-model="product.notes"
                        id="new-product-notes"
                        class="product-notes-collapse"
                        rows="3"
                    />

                </div>
                <div class="modal-footer py-2">
                    <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">
                        <AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />
                        {{$t('close')}}
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm btn-success"
                        :disabled="loading || !isFormValid"
                        @click="saveRow"
                    >
                        <AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />
                        {{loading ? $t('saving') : $t('create')}}
                    </button>
                </div>
                </div>
            </div>

        </div>

        <add-supplier v-if="createSuplierState" :state="createSuplierState" @createSupplier="createSupplier"/>

        <add-category v-if="createCategoryState" :state="createCategoryState" @createCategory="createCategory"/>

        <add-warehouse v-if="createWarehouseState" :state="createWarehouseState" @createWarehouse="createWarehouse"/>

        <!-- Barcode Modal -->
        <div class="modal fade" id="barcode-modal-create" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="barcode-modal-create" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-white border-bottom">
                        <h5 class="modal-title">{{$t('barcode_options')}}</h5>
                        <button type="button" class="btn-close" @click="closeBarcodeModal" aria-label="close"></button>
                    </div>
                    <div class="modal-body bg-white">
                        <!-- Scanner View -->
                        <div v-if="barcodeScanning">
                            <div class="text-center mb-3">
                                <p class="text-muted">{{$t('point_camera_at_barcode')}}</p>
                            </div>
                            <div class="position-relative" style="background: #000; border-radius: 8px; overflow: hidden;">
                                <video ref="barcodeVideo" autoplay playsinline style="width: 100%; height: 300px; object-fit: cover;"></video>
                                <canvas ref="barcodeCanvas" style="display: none;"></canvas>
                            </div>
                            <div class="mt-3 text-center">
                                <button class="btn btn-danger" @click="closeBarcodeModal">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-2" />
                                    {{$t('cancel')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from '../helper'
import autoComplete from './autocomplete/AutoComplete'
import AddSupplier from '../components/AddSupplier.vue'
import addCategory from './AddCategory.vue'
import addWarehouse from '../components/AddWarehouse.vue'
import { getInventoryProductColumnDefaults } from '../constants/inventoryProductColumns'
const maxAllowedSize = 5 * 1024 * 1024; //5MB

export default {
  name: 'AddProduct',
  props : ['state', 'initialBarcode'],
  components : {
    autoComplete,
    AddSupplier,
    addCategory,
    addWarehouse
  },
  data(){
    return {
        product : {
            label : '',
            sku : '',
            description : '',
            barcode : '',
            supplier_id : null,
            category_id : null,
            notes : '',
            inventories : [],
            supplier : { name : '' },
            category : { name : '' },
            has_variants: false,
            variants: [],
            price_includes_tax: false,
            price_with_tax: 0,
            vat: 0,
            purchase_price: 0,
            price: 0,
            quantity: 0,
            min_quantity: 0,
            unity: 'unit',
            unity_width: null,
            unity_length: null,
            warehouse_id: null,
            warehouse: { name: '' }
        },
        createProductModal : null,
        loading : false,
        createSuplierState : false,
        createCategoryState : false,
        createWarehouseState : false,
        notesExpanded: false,
        imageFile: null,
        barcodeModal: null,
        barcodeScanning: false,
        barcodeStream: null,
        barcodeAnimationFrame: null,
        currentVariantIndex: null,
        barcodeMode: null, // 'product' or 'variant'
        visibleColumns: getInventoryProductColumnDefaults()
    }
  },
  mounted(){
    // eslint-disable-next-line no-undef
    this.createProductModal = new bootstrap.Modal(document.getElementById('product-create-modal-product'))
    if(this.state === true){
       this.createProductModal.show()
    }
    
    if(this.initialBarcode) {
        this.product.barcode = this.initialBarcode
    }

    document.getElementById('product-create-modal-product').addEventListener('hidden.bs.modal', (e) => { 
        if (e.target.id === 'product-create-modal-product') {
            this.$emit('createProduct',{state : false })
        }
    })
    
    // Load column visibility settings
    if (this.business?.metadata?.inventory_products_columns) {
        this.visibleColumns = {
            ...this.visibleColumns,
            ...this.business.metadata.inventory_products_columns
        };
    }


    // eslint-disable-next-line no-undef
    this.barcodeModal = new bootstrap.Modal(document.getElementById('barcode-modal-create'), {
      backdrop: 'static', 
      keyboard: false
    })
    
    const barcodeModalEl = document.getElementById('barcode-modal-create')
    
    // Prevent modal events from bubbling to parent modal
    barcodeModalEl.addEventListener('hidden.bs.modal', (e) => { 
      e.stopPropagation()
      this.stopBarcodeScanner()
    })
    
    barcodeModalEl.addEventListener('hide.bs.modal', (e) => {
      e.stopPropagation()
    })
    
    barcodeModalEl.addEventListener('show.bs.modal', (e) => {
      e.stopPropagation()
    })
    
    barcodeModalEl.addEventListener('shown.bs.modal', (e) => {
      e.stopPropagation()
    })
  },
  beforeUnmount() {
    // Clean up camera resources
    this.stopBarcodeScanner()
  },
  computed : {
    business(){ return this.$store.getters.BUSINESS },
    hasPrimaryProductFields() {
        return [
            'label', 'barcode', 'price', 'quantity', 'sku', 'supplier', 'category',
            'purchase_price', 'min_quantity', 'warehouse', 'unity', 'profit_margin',
            'has_variants'
        ].some(column => this.visibleColumns[column]);
    },
    hasAdditionalProductFields() {
        return [
            'sku', 'supplier', 'category', 'purchase_price', 'min_quantity',
            'warehouse', 'unity', 'profit_margin', 'has_variants'
        ].some(column => this.visibleColumns[column]);
    },
    isFormValid() {
        if (this.visibleColumns.label && (!this.product.label || this.product.label.length < 2)) return false;
        
        if (this.product.has_variants) {
            if (this.product.variants.length === 0) return false;
            // Check if all variants are valid
            return this.product.variants.every(v => {
                if (!v.name) return false;
                if (this.visibleColumns.purchase_price && v.purchase_price < 0) return false;
                if (this.visibleColumns.price && v.price < 0) return false;
                if (this.visibleColumns.quantity && v.quantity < 0) return false;
                if (this.visibleColumns.min_quantity && v.min_quantity < 0) return false;
                return true;
            });
        } else {
            if (this.visibleColumns.purchase_price && this.product.purchase_price < 0) return false;
            if (this.visibleColumns.price && this.product.price < 0) return false;
            if (this.visibleColumns.quantity && this.product.quantity < 0) return false;
            if (this.visibleColumns.min_quantity && this.product.min_quantity < 0) return false;
            return true;
        }
    },
    helper(){ return helper },
  },
  methods : {
    setPriceMode(includesTax) {
        if (this.product.price_includes_tax === includesTax) return;

        if (includesTax) {
            this.calculateTTCFromPrice();
        } else {
            this.calculatePriceFromTTC();
        }
        this.product.price_includes_tax = includesTax;
    },
    handleInputFocus(obj, field){
        if(obj[field] == 0){
            obj[field] = ''
        }
    },
    handleInputBlur(obj, field){
        if(obj[field] === '' || obj[field] === null || obj[field] === undefined){
            obj[field] = 0
            
            // Trigger calculations for main product fields
            if (obj === this.product) {
                if (field === 'price_with_tax' || field === 'vat') {
                    this.calculatePriceFromTTC();
                } else if (field === 'price' && !this.product.price_includes_tax) {
                    this.calculateTTCFromPrice();
                }
            }
        }
    },
    calculatePriceFromTTC() {
        if (this.product.price_includes_tax) {
            const ttc = Number(this.product.price_with_tax) || 0;
            const vat = Number(this.product.vat) || 0;
            // HT = TTC / (1 + VAT/100)
            const ht = ttc / (1 + (vat / 100));
            this.product.price = parseFloat(ht.toFixed(2));
        }
    },
    calculateTTCFromPrice() {
        if (!this.product.price_includes_tax) {
            const ht = Number(this.product.price) || 0;
            const vat = Number(this.product.vat) || 0;
            // TTC = HT * (1 + VAT/100)
            const ttc = ht * (1 + (vat / 100));
            this.product.price_with_tax = parseFloat(ttc.toFixed(2));
        }
    },
    calculateMargin() {
        const cost = Number(this.product.purchase_price) || 0;
        const price = Number(this.product.price) || 0;
        if (cost > 0) {
            const margin = ((price - cost) / cost) * 100;
            return margin.toFixed(2);
        }
        return '0.00';
    },
    onHasVariantsToggle() {
        if (this.product.has_variants && this.product.variants.length === 0) {
            // Optionally add a default variant
            this.addVariant();
        }
    },
    calculateCarpetArea() {
        if (this.product.unity === 'm²') {
            const w = Number(this.product.unity_width) || 0;
            const l = Number(this.product.unity_length) || 0;
            if (w > 0 && l > 0) {
                this.product.quantity = parseFloat((w * l).toFixed(3));
            }
        }
    },
    addVariant() {
        this.product.variants.push({
            name: '',
            sku: '',
            barcode: '',
            purchase_price: this.product.purchase_price || 0,
            price: this.product.price || 0,
            quantity: 0,
            min_quantity: 0,
            image: null
        });
    },
    removeVariant(index) {
        this.product.variants.splice(index, 1);
    },
    generateBarcodeString(){
      // Format: <productId><YYYY><MM><DD><HH><mm><ss>
      const idPart = this.product && this.product.id 
        ? String(this.product.id) 
        : String(Math.floor(100000 + Math.random() * 900000))
      const now = new Date()
      const yyyy = String(now.getFullYear())
      const MM = String(now.getMonth() + 1).padStart(2, '0')
      const dd = String(now.getDate()).padStart(2, '0')
      const HH = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      const ss = String(now.getSeconds()).padStart(2, '0')
      return `${idPart}${yyyy}${MM}${dd}${HH}${mm}${ss}`
    },
    openBarcodeModal() {
      this.barcodeScanning = false
      this.barcodeMode = 'product'
      this.currentVariantIndex = null
      this.barcodeModal.show()
    },
    openBarcodeModalForScan() {
      this.barcodeScanning = true
      this.barcodeMode = 'product'
      this.currentVariantIndex = null
      this.barcodeModal.show()
      this.$nextTick(() => {
        this.startBarcodeScanner()
      })
    },
    generateAndSetBarcode() {
      this.product.barcode = this.generateBarcodeString()
      // Generate directly without opening modal
    },
    closeBarcodeModal() {
      this.stopBarcodeScanner()
      this.barcodeModal.hide()
    },
    openVariantBarcodeModal(variantIndex, mode) {
      this.barcodeScanning = mode === 'scan'
      this.barcodeMode = 'variant'
      this.currentVariantIndex = variantIndex
      this.barcodeModal.show()
      
      if (mode === 'scan') {
        this.$nextTick(() => {
          this.startBarcodeScanner()
        })
      }
    },
    generateVariantBarcode(variantIndex) {
      const barcode = this.generateVariantBarcodeString(variantIndex)
      this.product.variants[variantIndex].barcode = barcode
    },
    generateVariantBarcodeString(variantIndex) {
      // Format: <productId or random><variant index><YYYY><MM><DD><HH><mm><ss>
      const idPart = this.product && this.product.id 
        ? String(this.product.id).substring(0, 6) 
        : String(Math.floor(100000 + Math.random() * 900000))
      const variantPart = String(variantIndex + 1).padStart(2, '0')
      const now = new Date()
      const yyyy = String(now.getFullYear()).substring(2) // Last 2 digits
      const MM = String(now.getMonth() + 1).padStart(2, '0')
      const dd = String(now.getDate()).padStart(2, '0')
      const HH = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      const ss = String(now.getSeconds()).padStart(2, '0')
      return `${idPart}${variantPart}${yyyy}${MM}${dd}${HH}${mm}${ss}`
    },
    downloadVariantBarcode(barcodeValue) {
      this.downloadBarcodeImage(barcodeValue)
    },
    downloadBarcodeImage(value) {
      try{
        if(!value) return
        const canvas = document.createElement('canvas')
        const scale = 4
        const width = 220 * scale
        const height = 80 * scale
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        // background
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0,0,width,height)
        // draw simple bars based on digits
        const digits = value.replace(/[^0-9]/g,'').split('').map(n=>parseInt(n,10))
        let x = 20
        const barWidth = 2 * scale
        const barMaxHeight = 50 * scale
        for(let i=0;i<digits.length;i++){
          const h = (10 + (digits[i] % 10) * 4) * scale
          ctx.fillStyle = '#000000'
          ctx.fillRect(x, (height - barMaxHeight) / 2 + (barMaxHeight - h), barWidth, h)
          x += barWidth + 1 * scale
        }
        // text
        ctx.fillStyle = '#000000'
        ctx.font = `${12*scale}px monospace`
        ctx.textAlign = 'center'
        ctx.fillText(value, width/2, height - 10*scale)
        const link = document.createElement('a')
        link.href = canvas.toDataURL('image/png')
        link.download = `barcode_${value}.png`
        link.click()
      }catch(e){
       alert('Barcode download error:', e)
      }
    },
    async startBarcodeScanner() {
      try {
        this.barcodeScanning = true
        
        // Request camera access
        const stream = await navigator.mediaDevices.getUserMedia({ 
          video: { facingMode: 'environment' } // Use back camera on mobile
        })
        
        this.barcodeStream = stream
        this.$refs.barcodeVideo.srcObject = stream
        
        // Start scanning loop
        this.scanBarcode()
      } catch (error) {
        alert('Error accessing camera:', error)
        this.$swal.fire({
          icon: 'error',
          title: this.$t('error'),
          text: this.$t('camera_access_denied')
        })
        this.barcodeScanning = false
      }
    },
    stopBarcodeScanner() {
      this.barcodeScanning = false
      
      // Stop camera stream
      if (this.barcodeStream) {
        this.barcodeStream.getTracks().forEach(track => track.stop())
        this.barcodeStream = null
      }
      
      // Cancel animation frame
      if (this.barcodeAnimationFrame) {
        cancelAnimationFrame(this.barcodeAnimationFrame)
        this.barcodeAnimationFrame = null
      }
      
      // Clear video source
      if (this.$refs.barcodeVideo) {
        this.$refs.barcodeVideo.srcObject = null
      }
    },
    async scanBarcode() {
      if (!this.barcodeScanning) return
      
      const video = this.$refs.barcodeVideo
      const canvas = this.$refs.barcodeCanvas
      
      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        const context = canvas.getContext('2d')
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        context.drawImage(video, 0, 0, canvas.width, canvas.height)
        
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
        
        // Use BarcodeDetector API if available
        if ('BarcodeDetector' in window) {
          try {
            const barcodeDetector = new window.BarcodeDetector()
            const barcodes = await barcodeDetector.detect(imageData)
            
            if (barcodes.length > 0) {
              const detectedBarcode = barcodes[0].rawValue
              
              // Set barcode based on mode
              if (this.barcodeMode === 'variant' && this.currentVariantIndex !== null) {
                this.product.variants[this.currentVariantIndex].barcode = detectedBarcode
              } else {
                this.product.barcode = detectedBarcode
              }
              
              this.stopBarcodeScanner()
              this.barcodeModal.hide()
              
              this.$swal.fire({
                icon: 'success',
                title: this.$t('barcode_detected'),
                text: detectedBarcode,
                timer: 2000,
                showConfirmButton: false
              })
              return
            }
          } catch (error) {
            alert('Barcode detection error:', error)
          }
        }
      }
      
      // Continue scanning
      this.barcodeAnimationFrame = requestAnimationFrame(() => this.scanBarcode())
    },
    downloadBarcode(){
      const value = (this.product && this.product.barcode) ? String(this.product.barcode) : ''
      this.downloadBarcodeImage(value)
    },
    handleFileDrop(event) {
        const file = event.dataTransfer.files[0];
        if (file) {
            this.processFile(file);
        }
    },
    handleFileUpload(event) {
        const file = event.target.files[0];
        if (file) {
            this.processFile(file);
        }
    },
    async processFile(file) {
        if (file.size > maxAllowedSize) {
            alert('File too large. Please upload a file less than 5MB.');
            return;
        }
        this.loading = true;
        this.imageFile = file;
        this.product.image = URL.createObjectURL(file);
        
        try {
            const url = await this.onUpload(file);
            this.product.image = url;
        } catch (error) {
            alert(error.message)
            this.$toast.error('Image upload failed');
        } finally {
            this.loading = false;
        }
    },
    async handleVariantFileUpload(event, index) {
        const file = event.target.files[0];
        if (!file) return;
        
        if (file.size > maxAllowedSize) {
            alert('File too large. Please upload a file less than 5MB.');
            return;
        }

        try {
            const url = await this.onUpload(file);
            this.product.variants[index].image = url;
        } catch (error) {
            alert(error.message)
            this.$toast.error('Image upload failed');
        }
    },
    async onUpload(file){
        return helper.customUploadFile(file,`businesses/${this.business.id}/attachments/${helper.generateRandString(20)}`,{products:true})
    },
    clearForm(){
        this.product = {
            label : '',
            sku : '',
            description : '',
            barcode : '',
            supplier_id : null,
            category_id : null,
            notes : '',
            inventories : [],
            supplier : { name : '' },
            category : { name : '' },
            has_variants: false,
            variants: [],
            price_includes_tax: false,
            price_with_tax: 0,
            vat: 0,
            purchase_price: 0,
            price: 0,
            quantity: 0,
            min_quantity: 0,
            warehouse_id: null,
            warehouse: { name: '' }
        }
        this.notesExpanded = false;
        this.imageFile = null;
    },
    emitAutoCompleteSupplier(data){
        this.product.supplier_id = data.result.id
        this.product.supplier = data.result
    },
    emitAutoCompleteCategory(data){
        this.product.category_id = data.result.id
        this.product.category = data.result
    },
    createWarehouse(data){
        if(data.warehouse){
            this.product.warehouse_id = data.warehouse.id
            this.product.warehouse = data.warehouse
        }
        if(data && data.state != undefined){
            this.createWarehouseState = data.state
        }
    },
     openCreateSupplierModal(){
        this.createSuplierState = !this.createSuplierState
    },
    openCreateCategoryModal(){
        this.createCategoryState = !this.createCategoryState
    },
    openCreateWarehouseModal(){
        this.createWarehouseState = !this.createWarehouseState
    },
     emitAutoCompleteWarehouse(data){
        this.product.warehouse_id = data.result.id
        this.product.warehouse = data.result
    },
    createCategory(data){
        if(data.category){
            this.product.category_id = data.category.id
            this.product.category = data.category
        }
        if(data && data.state != undefined){
            this.createCategoryState = data.state
        }
    },
    createSupplier(data){
        if(data.supplier){
            this.product.supplier_id = data.supplier.id
            this.product.supplier = data.supplier
        }
        if(data && data.state != undefined){
            this.createSuplierState = data.state
        }
    },
     async saveRow(){
        try{
            this.loading = true;

            if(this.has_variants == false){
                this.product.variants = []
            }
            const response = await helper.customPost(`${process.env.VUE_APP_API}/products`,this.product,{showToast:true})
            this.loading = false;
            this.$emit('createProduct',
            {
                product : response.data.product,
                inventory : response.data.inventory, 
                state : false 
            })
            this.clearForm()
            this.createProductModal.hide()
        }catch(error){
            this.loading = false;
        }

    },
  }
}
</script>

<style scoped>
    .product-create-dialog { max-width: 960px; }

    .product-create-modal {
        border: 0;
        border-radius: 18px;
        box-shadow: 0 24px 80px rgba(15, 23, 42, 0.18);
        overflow: hidden;
    }

    .product-create-header {
        align-items: flex-start;
        border-bottom: 0;
        padding: 1.7rem 2rem 0.75rem;
    }

    .product-create-header .modal-title {
        color: #172033;
        font-size: 1.55rem;
        font-weight: 750;
        line-height: 1.25;
        margin-bottom: 0.35rem;
    }

    .product-create-subtitle { color: #8490a5; font-size: 0.95rem; }
    .product-create-header .btn-close { margin-top: 0.15rem; }

    .product-create-body {
        background: #fff;
        max-height: 72vh;
        overflow-y: auto;
        padding: 1.25rem 2rem 0;
        text-align: start;
    }

    .product-field { margin-bottom: 1.4rem; }

    .product-flex-fields {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
    }

    .product-flex-field {
        flex: 1 1 16rem;
        min-width: 0;
    }

    .product-flex-field--full {
        flex-basis: 100%;
    }

    .product-variant-fields .product-flex-field {
        flex-basis: 11rem;
    }

    .product-field-label {
        color: #25324a;
        display: block;
        font-size: 0.95rem;
        font-weight: 650;
        margin-bottom: 0.55rem;
    }

    .product-control,
    .product-input-group .product-control {
        border-color: #d8deea;
        border-radius: 10px;
        color: #263248;
        font-size: 0.95rem;
        line-height: 1.5;
        min-height: 37px;
        padding: 6px 16px;
    }

    .product-control::placeholder { color: #9ca7ba; opacity: 1; }

    .product-control:focus {
        border-color: #1d63d4;
        box-shadow: 0 0 0 3px rgba(29, 99, 212, 0.12);
    }

    .product-input-group .product-control {
        border-end-end-radius: 0;
        border-start-end-radius: 0;
    }

    .product-barcode-button,
    .product-currency {
        background: #f8fafc;
        border-color: #d8deea;
        color: #607089;
        min-width: 58px;
    }

    .product-barcode-button {
        border-end-end-radius: 10px;
        border-start-end-radius: 10px;
        font-size: 1.2rem;
    }

    .product-barcode-button::after { display: none; }

    .product-currency {
        border-end-end-radius: 10px;
        border-start-end-radius: 10px;
        font-weight: 650;
        justify-content: center;
    }

    .product-price-heading {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.55rem;
        min-height: 37px;
    }

    .product-field-label-aligned {
        align-items: center;
        display: flex;
        min-height: 37px;
    }

    .product-price-switch {
        align-items: center;
        display: flex;
        gap: 0.35rem;
        margin: 0;
        min-height: 28px;
    }

    .product-price-switch .form-check-input {
        cursor: pointer;
        margin-left: 0;
        margin-top: 0;
    }

    .product-price-switch .form-check-label {
        color: #475569;
        cursor: pointer;
        font-size: 0.82rem;
        font-weight: 600;
        white-space: nowrap;
    }

    .price-mode-toggle {
        background: #f3f6fb;
        border: 1px solid #d8deea;
        border-radius: 9px;
        display: inline-flex;
        padding: 2px;
    }

    .price-mode-option {
        background: transparent;
        border: 0;
        border-radius: 7px;
        color: #475569;
        font-size: 0.82rem;
        font-weight: 700;
        min-width: 54px;
        padding: 0.4rem 0.75rem;
    }

    .price-mode-option.active {
        background: #1461c9;
        box-shadow: 0 2px 6px rgba(20, 97, 201, 0.24);
        color: #fff;
    }

    .product-image-dropzone {
        align-items: center;
        aspect-ratio: 1 / 1;
        background: #fbfcfe;
        border: 2px dashed #cbd3e1;
        border-radius: 12px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        min-height: 230px;
        overflow: hidden;
        padding: 1.25rem;
        text-align: center;
        transition: border-color 0.2s ease, background 0.2s ease;
    }

    .product-image-dropzone:hover,
    .product-image-dropzone:focus-visible {
        background: #f4f8ff;
        border-color: #2b6ed2;
        outline: none;
    }

    .product-image-placeholder {
        align-items: center;
        color: #27344d;
        display: flex;
        flex-direction: column;
        gap: 0.55rem;
    }

    .product-upload-icon { color: #64748b; font-size: 2.7rem; }
    .product-image-placeholder strong { font-size: 0.98rem; }
    .product-image-placeholder span { color: #8a96aa; font-size: 0.78rem; }

    .product-image-preview {
        height: 100%;
        object-fit: contain;
        width: 100%;
    }

    .product-additional-fields {
        margin-top: 0.35rem;
    }

    .product-additional-heading {
        border-top: 1px solid #e3e8f0;
        color: #64748b;
        font-size: 0.8rem;
        font-weight: 700;
        letter-spacing: 0.04em;
        margin-top: 1.4rem;
        padding-top: 1rem;
        text-transform: uppercase;
    }

    .product-create-related {
        display: inline-block;
        font-size: 0.78rem;
        margin-top: 0.4rem;
        text-decoration: none;
    }

    .product-variants-toggle {
        align-items: center;
        background: #f8fafc;
        border: 1px solid #e1e7ef;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        padding: 0.9rem 1rem;
    }

    .product-variants-toggle strong,
    .product-variants-toggle small {
        display: block;
    }

    .product-variants-toggle strong {
        color: #25324a;
        font-size: 0.9rem;
    }

    .product-variants-toggle small {
        color: #8490a5;
        font-size: 0.75rem;
        margin-top: 0.15rem;
    }

    .product-variants-header,
    .product-variant-card-header {
        align-items: center;
        display: flex;
        justify-content: space-between;
    }

    .product-variants-header {
        margin-bottom: 0.75rem;
    }

    .product-variant-card {
        border: 1px solid #e1e7ef;
        border-radius: 10px;
        margin-bottom: 0.75rem;
        padding: 1rem;
    }

    .product-variant-card-header {
        border-bottom: 1px solid #edf0f5;
        margin-bottom: 0.9rem;
        padding-bottom: 0.65rem;
    }

    .product-notes-panel { padding-top: 0.8rem; }

    .product-notes-field {
        border-top: 1px solid #e3e8f0;
        margin-top: 1.5rem;
        padding: 1rem 0 1.25rem;
    }

    .product-create-footer {
        background: #fff;
        border-top: 1px solid #e8ecf2;
        gap: 0.75rem;
        padding: 1rem 2rem 1.25rem;
    }

    .product-cancel-button,
    .product-submit-button {
        border-radius: 9px;
        font-size: 0.92rem;
        font-weight: 700;
        min-height: 46px;
        min-width: 132px;
        padding: 0.65rem 1.25rem;
    }

    .product-cancel-button { background: #fff; border: 1px solid #d6dce7; color: #344054; }
    .product-submit-button { background: #1261cf; border: 1px solid #1261cf; color: #fff; }
    .product-submit-button:hover:not(:disabled) { background: #0d51b3; border-color: #0d51b3; }
    .product-submit-button:disabled { background: #8eb4e8; border-color: #8eb4e8; color: #fff; }

    @media (max-width: 991.98px) {
        .product-create-dialog { margin: 1rem; }
        .product-image-dropzone { aspect-ratio: auto; min-height: 180px; }
    }

    @media (max-width: 575.98px) {
        .product-create-header,
        .product-create-body,
        .product-create-footer { padding-left: 1rem; padding-right: 1rem; }
        .product-create-header .modal-title { font-size: 1.3rem; }
        .product-price-heading { align-items: flex-start; flex-direction: column; gap: 0.5rem; }
        .product-field-label-aligned { min-height: auto; }
        .product-create-footer { flex-wrap: nowrap; }
        .product-cancel-button,
        .product-submit-button { flex: 1 1 0; min-width: 0; }
    }

    .form-label-compact {
        font-size: 0.85rem;
        font-weight: 500;
        margin-bottom: 0.25rem;
        color: #495057;
    }
    
    .section-header-compact {
        border-bottom: 1px solid #eee;
        padding-bottom: 0.5rem;
    }

    .product-notes-collapse {
        border-top: 1px solid #e3e8f0;
        margin-top: 2rem;
        padding: 1rem 0 1.25rem;
    }

    .product-notes-toggle {
        align-items: center;
        background: transparent;
        border: 0;
        color: #344054;
        display: flex;
        font-size: 0.95rem;
        font-weight: 600;
        gap: 0.65rem;
        padding: 0.35rem 0;
        text-align: start;
        width: 100%;
    }

    .product-notes-toggle:hover {
        color: var(--bs-primary);
    }

    .product-notes-toggle:focus-visible {
        border-radius: 0.25rem;
        outline: 2px solid var(--bs-primary);
        outline-offset: 2px;
    }

    .product-notes-chevron {
        flex: 0 0 auto;
        font-size: 1rem;
    }

    .product-notes-optional {
        color: #98a2b3;
        font-weight: 400;
    }

    .drop-zone-compact {
        border: 2px dashed #ccc;
        border-radius: 6px;
        padding: 10px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        background: #f8f9fa;
        min-height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .drop-zone-compact:hover {
        border-color: #534dff;
        background: #f0f0ff;
    }

    .drop-zone-compact.has-image {
        padding: 0;
        border: none;
        background: transparent;
    }

    .preview-image-compact {
        width: 100%;
        height: 200px;
        object-fit: contain;
        border-radius: 6px;
        background-color: #f8f9fa;
    }

    .variant-preview-image {
        object-fit: cover;
        border-radius: 4px;
        border: 1px solid #dee2e6;
    }
</style>
